export const getBaseUrl = () => {
  const full = window.location.href;
  const url = new URL(full);
  return url.origin;
};
export const getApiBase = () => {
  if (typeof window !== 'undefined' && window.__API_BASE__) {
    return window.__API_BASE__.replace(/\/$/, '');
  }
  if (typeof process !== 'undefined' && process.env?.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/$/, '');
  }
  return getBaseUrl() + '/api';
};
export const getRestApiUrl = () => getApiBase();
export const buildRedirectUrl = params => {
  const baseUrl = getBaseUrl();
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      queryParams.append(key, value);
    }
  });
  const queryString = queryParams.toString();
  const redirectPage = window.nitromuleReactData?.quoteRedirectPage || 'get-label';
  const redirectPath = redirectPage ? `/${redirectPage.replace(/^\//, '')}` : '/';
  return queryString ? `${baseUrl}${redirectPath}?${queryString}` : `${baseUrl}${redirectPath}`;
};
export const buildPackageRedirectUrl = rate => {
  return buildRedirectUrl({
    category: rate.category
  });
};
export const buildDimensionsRedirectUrl = (dimensions, fromDropdown = false, category = null) => {
  if (fromDropdown) {
    return buildRedirectUrl({});
  }
  const {
    length,
    width,
    height,
    weight
  } = dimensions;
  const dimH = Number(height);
  const dimW = Number(width);
  const dimL = Number(length);
  const allDimensions = [dimL, dimW, dimH];
  const maxIndex = allDimensions.indexOf(Math.max(...allDimensions));
  const remainingDimensions = [...allDimensions];
  remainingDimensions.splice(maxIndex, 1);
  const calculatedHeight = remainingDimensions[0];
  const calculatedWidth = remainingDimensions[1];
  const params = {
    length: Math.max(...allDimensions),
    width: calculatedWidth,
    height: calculatedHeight,
    weight
  };
  if (category) {
    params.category = category;
  }
  try {
    sessionStorage.removeItem('quoteRates');
  } catch (_) {}
  return buildRedirectUrl(params);
};
export const safeRedirectUrl = (redirectUrl, fallback = '/') => {
  if (!redirectUrl || redirectUrl === 'none') {
    return fallback;
  }
  try {
    const url = new URL(redirectUrl, window.location.origin);
    return url.href;
  } catch (error) {
    console.error('Invalid redirect URL:', error?.message || error);
    return fallback;
  }
};
